
import { PassMdl } from './../../../Models/TravelProposalMdl';
import { Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TravelBindMdl, TravelstatusMdl } from './../../../Models/TravelBindMdl';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { restURL } from '../../../Models/restURL';
import { TravelPolicyModel } from '../../../Models/TravelPolicyModel';
import { LanguageService } from '../../../Services/languageService';
import { userService } from '../../../Services/userService';
import * as $ from 'jquery';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import 'moment-hijri'
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import { motorProposalService } from '../../../Services/motorProposalService';
import { MotorStatusMdl } from '../../../Models/MotorStatusMdl';
import swal from 'sweetalert2';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'TravelNewProposal',
  templateUrl: './TravelNewProposal.html',
  styleUrls: ['./TravelNewProposal.css']
})
export class TravelNewProposal {
  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public travelBindObj: TravelBindMdl = new TravelBindMdl();
  public travelPolicyObj: TravelPolicyModel = new TravelPolicyModel();
  public st: TravelstatusMdl = new TravelstatusMdl();
  public isShowLoading: boolean = false;
  public LngSubscription: Subscription;
  public Lng: string;
  public curDate: Date = new Date();
  public minDate: Date = new Date();
  public maxDate: Date = new Date();
  public passObj: PassMdl = new PassMdl();
  public ToDateEnable: boolean;
  public FromDate: Date;
  public TravelToDate: Date;
  public TravelFromDate: Date;
  public IdExists: boolean;
  public modal: boolean;
  public DoBmaxDate: Date = new Date();
  public HasSaudiAddress: boolean;
  public IsDate: boolean;
  public From: any;
  public To: any;
  public EditTravelToDate: Date;
  public EditTravelFromDate: Date;
  public DOB: any;
  public TravelLogoTooltip: string;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  public headers = new HttpHeaders();
  public AttachementError: string = "";


  public searchAir: any;


  constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private lngService: LanguageService, private userinfo: userService) {
    this.IdExists = false;
    this.HasSaudiAddress = true;
    this.minDate.setDate(this.curDate.getDate() + 1);
    this.DoBmaxDate.setDate(this.curDate.getDate() - 1);
    let MDate: string;
    var date = this.minDate.getDate() < 10 ? "0" + this.minDate.getDate() : this.minDate.getDate();
    var month = this.minDate.getMonth() + 1 < 10 ? "0" + (this.minDate.getMonth() + 1) : this.minDate.getMonth() + 1;
    MDate = month + "/" + date.toString() + "/" + (this.minDate.getFullYear() + 1);
    this.maxDate = new Date(MDate);

    this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
      this.Lng = lng;
      if (this.Lng == "ar") {
        this.TravelLogoTooltip = "تشمل التغطية التأمينية المخاطر المتعلقة بالسفر الدولي والتي قد تؤدي إلى خسائر بسبب بعض الحوادث العرضية مثل إلغاء الرحلة أو فوات موعد رحلة المغادرة بسبب خارج عن الارادة أو فقدان الحقائب أو تأخر وصولها في الوقت المناسب٬ كما تشمل تغطية المصاريف الطبية الطارئة والحوادث الشخصية والمسؤولية تجاه الغير والتثبت من منح المؤمن له الطمانينة والتمتع براحة البال أثناء السفر، وذلك حسب شروط وبنود وإستثناءات وثيقة تأمين السفر.";
      } else {
        this.TravelLogoTooltip = "Insurance coverage includes risks related to international travel which may result in losses due to occasional accidents such as canceling the flight or late departure due to out-of-will baggage or delayed arrival in a timely manner, and covering emergency medical expenses, personal accidents and third-party liability and verification From granting the Insured the right to enjoy peace of mind while traveling, all as per the terms and conditions and exclusions of the Travel Insurance Policy.";
      }
    });
    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
      if (this.Lng == "ar") {
        this.TravelLogoTooltip = "تشمل التغطية التأمينية المخاطر المتعلقة بالسفر الدولي والتي قد تؤدي إلى خسائر بسبب بعض الحوادث العرضية مثل إلغاء الرحلة أو فوات موعد رحلة المغادرة بسبب خارج عن الارادة أو فقدان الحقائب أو تأخر وصولها في الوقت المناسب٬ كما تشمل تغطية المصاريف الطبية الطارئة والحوادث الشخصية والمسؤولية تجاه الغير والتثبت من منح المؤمن له الطمانينة والتمتع براحة البال أثناء السفر، وذلك حسب شروط وبنود وإستثناءات وثيقة تأمين السفر.";
      } else {
        this.TravelLogoTooltip = "Insurance coverage includes risks related to international travel which may result in losses due to occasional accidents such as canceling the flight or late departure due to out-of-will baggage or delayed arrival in a timely manner, and covering emergency medical expenses, personal accidents and third-party liability and verification From granting the Insured the right to enjoy peace of mind while traveling, all as per the terms and conditions and exclusions of the Travel Insurance Policy.";
      }
    } else {
      this.Lng = "en";
      this.TravelLogoTooltip = "Insurance coverage includes risks related to international travel which may result in losses due to occasional accidents such as canceling the flight or late departure due to out-of-will baggage or delayed arrival in a timely manner, and covering emergency medical expenses, personal accidents and third-party liability and verification From granting the Insured the right to enjoy peace of mind while traveling, all as per the terms and conditions and exclusions of the Travel Insurance Policy.";
    }
    this.travelPolicyObj.IqamaNo = sessionStorage.getItem("IqamaNo");
    this.travelPolicyObj.RegNo = sessionStorage.getItem("RegNo");

    if (sessionStorage.getItem("IsTravelEdit") == "Y") {
      //this.travelPolicyObj = JSON.parse(sessionStorage.getItem("newTravelPolicyObj"));
      this.travelPolicyObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("newTravelPolicyObj")));

    }



    this.bindTravelInfo();


  }

  bindTravelInfo() {
    this.isShowLoading = true;
    this.travelPolicyObj.IqamaNo = sessionStorage.getItem("IqamaNo");
    this.travelPolicyObj.RegNo = sessionStorage.getItem("RegNo");

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.travelPolicyObj));

    //this.http.post<TravelBindMdl>(this.url.baseURL+"travelBind/getTravelBindInfo",this.travelPolicyObj,this.userinfo.getHttpOptions()).toPromise().then((result)=>{
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "travelBind/getTravelBindInfo", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      // this.travelBindObj=result;
      this.isShowLoading = false;

      // //New Line Start
      // this.objPayloadResponse = result;
      // this.travelBindObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      // //NewLine End

      //New Line Start
      this.objPayloadResponse = result;

      let objResObj: TravelBindMdl = new TravelBindMdl();
      objResObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      if (objResObj.propoalObj.RegNo != this.travelPolicyObj.RegNo) {
        Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
        this.router.navigate(['BeforeLogin/NewReg']);
        return;
      }
      this.travelBindObj = objResObj;
      //NewLine End

      if (this.travelBindObj.st.StatusCode == "F") {
        Swal("Error",this.travelBindObj.st.StatusDesc, "error")
        this.router.navigate(['NewDashboard/Welcome']);
        return;
      }


      if (this.travelBindObj.st.StatusCode == "Y") {
        this.HasSaudiAddress = false;
        this.isShowLoading = false;
        //this.Lng=="en"?alert(this.travelBindObj.st.StatusDesc):alert(this.travelBindObj.st.StatusDescAr);
        //alert(this.travelBindObj.st.StatusDesc);
        if (this.Lng == "en") {
          let stHTML: string;
          stHTML = "<p style='font-size:16px;'>Dear customer Please register or update your own National Address: <a href='https://register.address.gov.sa/ar/individual/' target='_blank'>https://register.address.gov.sa/ar/individual/" + "</a></p>";
          Swal({
            title: '',
            html: stHTML,
            type: "info",
            width: '50%',
          });
        } else {
          let stHTML: string;
          stHTML = "<p style='font-size:16px;'>عزيزنا العميل نرجو تسجيل أو تحديث بياناتك في العنوان الوطني عن طريق الرابط التالي<a href='https://register.address.gov.sa/ar/individual/' target='_blank'>https://register.address.gov.sa/ar/individual/" + "</a></p>";
          Swal({
            title: '',
            html: stHTML,
            type: "info",
            width: '50%',
          });
        }
        //this.Lng == "en" ? alert("Dear customer Please register or update your own National Address:https://register.address.gov.sa/ar/individual/") : alert("عزيزنا العميل نرجو تسجيل أو تحديث بياناتك في العنوان الوطني عن طريق الرابط التالي:https://register.address.gov.sa/ar/individual/");
      }
      else {
        if (sessionStorage.getItem("IsTravelEdit") == "N") {
          this.travelBindObj.propoalObj.TravelFrom = new Date();
          this.travelBindObj.propoalObj.TravelFrom.setDate(this.curDate.getDate() + 1);
          this.travelBindObj.propoalObj.TravelTo = new Date();
          this.travelBindObj.propoalObj.TravelTo.setDate(this.curDate.getDate() + 1);
          this.travelBindObj.propoalObj.NoofDays = 1;
          this.travelBindObj.propoalObj.ZoneCode = "";
          this.travelBindObj.propoalObj.PlanCode = "";
          this.travelBindObj.propoalObj.InsuranceType = "";
          this.FromDate = this.travelBindObj.propoalObj.TravelFrom;
          this.isShowLoading = false;
        } else if (sessionStorage.getItem("IsTravelEdit") == "Y") {
          let FDate: string;
          var tfrom = this.travelBindObj.propoalObj.TravelFrom.toString().split('T');
          let fromdt = tfrom[0];
          var dateformat = new Date(fromdt);
          var date = dateformat.getDate() < 10 ? "0" + dateformat.getDate() : dateformat.getDate();
          var month = dateformat.getMonth() + 1 < 10 ? "0" + (dateformat.getMonth() + 1) : dateformat.getMonth() + 1;
          FDate = month + "/" + date.toString() + "/" + dateformat.getFullYear();
          this.travelBindObj.propoalObj.TravelFrom = new Date(FDate);
          let TDate: string;
          var tTo = this.travelBindObj.propoalObj.TravelTo.toString().split('T');
          let Todt = tTo[0];
          var Todateformat = new Date(Todt);
          var date = Todateformat.getDate() < 10 ? "0" + Todateformat.getDate() : Todateformat.getDate();
          var month = Todateformat.getMonth() + 1 < 10 ? "0" + (Todateformat.getMonth() + 1) : Todateformat.getMonth() + 1;
          TDate = month + "/" + date.toString() + "/" + Todateformat.getFullYear();
          this.travelBindObj.propoalObj.TravelTo = new Date(TDate);
          document.getElementById("optionDeparture").innerHTML = this.travelBindObj.destList.filter(obj => obj.DestinationId.toString() == this.travelBindObj.propoalObj.DepartureAirport)[0].DestinationNameEn
          this.isShowLoading = false;
        }
      }
    }, (error) => {
      this.isShowLoading = false;
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");

    });
  }

  TravelValidate() {
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.travelBindObj.propoalObj.Insured_IDNo));

    //this.http.get<TravelstatusMdl>(this.url.baseURL+"travelBind/ValidateTravelCount?InsuredNo="+this.travelBindObj.propoalObj.Insured_IDNo,this.userinfo.getHttpOptions()).toPromise().then((result)=>{
    this.http.get<mdlPayloadResponse>(this.url.baseURL + "travelBind/ValidateTravelCount?InsuredNo=" + this.objPayloadRequest.Payload, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //this.st=result;
      this.isShowLoading = false;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End



    }, (error) => {
      this.isShowLoading = false;
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
    });
  }

  ValidateIdentityNo(evt: any) {
    var regx: any = /[0-9]/

    if (this.passObj.IdentityNo.length == 10) {
      this.passObj.IDCopy = null;
      this.passObj.IDCopyName = null;
      this.passObj.PassportCopy = null;
      this.passObj.PassportCopyName = null;
    }
    if (regx.test(evt.key)) {

      return true;

    }
    return false;

  }

  ValidatePassportNo(evt: any) {
    var regx: any = /[0-9a-zA-Z]/
    if (regx.test(evt.key)) {

      return true;
    }
    return false;

  }

  closemodal() {
    this.modal = false;
  }
  FamilyModal() {

    this.modal = true;
  }


  BUYPolicy(valid: boolean) {

    // if(this.travelBindObj.propoalObj.DepartureAirport == undefined || null || ""){
    //   Swal("Please Select Departure Airport")
    //   return
    // }

    if (this.travelBindObj.propoalObj.PlanCode == "0") {
      Swal("Empty Plan Type", "Please select a plan type to proceed further", "info");
      return;
    }

    if (valid) {
      if (this.travelBindObj.propoalObj.InsuranceType == "2") {

        if (this.travelBindObj.propoalObj.passList.length == 0) {
          this.Lng == "en" ? Swal("Add Atleast One Family Member") : Swal("أضف على الأقل عضو واحد من العائلة");
        }
        else {
          this.CalculatePremium();
        }

      }
      else {
        this.CalculatePremium();
      }
    }
    else {
      this.Lng == "en" ? Swal("Please Enter All Fields") : Swal("يرجى إدخال جميع الحقول");

    }

  }
  CalculateDays(DateType: string) {

    this.TravelFromDate = new Date();
    this.TravelFromDate = this.curDate;

    this.TravelToDate = new Date();
    this.TravelToDate = this.curDate;

    if (this.travelBindObj.propoalObj.TravelTo.toString() == "Invalid Date") {
      this.Lng == "en" ? Swal("Enter Valid Date") : Swal("أدخل تاريخ صالح");
      this.travelBindObj.propoalObj.TravelTo = null;
      this.travelBindObj.propoalObj.NoofDays = 0;

    }
    else {
      var difference_ms = 0;
      var one_day = 1000 * 60 * 60 * 24;

      // Convert both dates to milliseconds

      var date1_ms = this.travelBindObj.propoalObj.TravelFrom.getTime();
      var date2_ms = this.travelBindObj.propoalObj.TravelTo.getTime();
      this.From = date1_ms;
      this.To = date2_ms;

      // Calculate the difference in milliseconds
      var difference_ms = date2_ms - date1_ms;
      // Convert back to days and return
      //this.travelBindObj.propoalObj.NoofDays = Math.round(difference_ms/one_day)+1;  
      this.travelBindObj.propoalObj.NoofDays = Math.ceil(difference_ms / one_day);
      this.travelBindObj.propoalObj.NoofDays = this.travelBindObj.propoalObj.NoofDays + 1;
      if (this.travelBindObj.propoalObj.TravelFrom < this.TravelFromDate) {
        this.travelBindObj.propoalObj.TravelTo = new Date();
        this.travelBindObj.propoalObj.TravelTo.setDate(this.curDate.getDate() + 1);
        this.travelBindObj.propoalObj.TravelFrom = new Date();
        this.travelBindObj.propoalObj.TravelFrom.setDate(this.curDate.getDate() + 1);
        this.travelBindObj.propoalObj.NoofDays = 1;
        this.Lng == "en" ? Swal("Travel From Date Must be Greater than Current Date") : Swal("يجب أن يكون بداية تاريخ السفر اكبرمن التاريخ الحالي");
      }
      else if (this.travelBindObj.propoalObj.TravelTo < this.TravelToDate) {
        this.travelBindObj.propoalObj.TravelTo = new Date();
        this.travelBindObj.propoalObj.TravelTo.setDate(this.curDate.getDate() + 1);
        this.travelBindObj.propoalObj.TravelFrom = new Date();
        this.travelBindObj.propoalObj.TravelFrom.setDate(this.curDate.getDate() + 1);
        this.travelBindObj.propoalObj.NoofDays = 1;
        this.Lng == "en" ? Swal("Travel To Date Must be Greater than Current Date") : Swal("يجب أن يكون نهاية تاريخ السفر أكبر من التاريخ الحالي");
      }
      else if (this.travelBindObj.propoalObj.TravelTo < this.travelBindObj.propoalObj.TravelFrom) {
        this.travelBindObj.propoalObj.TravelTo = new Date();
        this.travelBindObj.propoalObj.TravelTo.setDate(this.curDate.getDate() + 1);
        this.travelBindObj.propoalObj.TravelFrom = new Date();
        this.travelBindObj.propoalObj.TravelFrom.setDate(this.curDate.getDate() + 1);
        this.travelBindObj.propoalObj.NoofDays = 1;
        this.Lng == "en" ? Swal("Travel To Must be greater than Travel From Date") : Swal("نهاية تاريخ السفر  يجب أن يكون أكبر من بداية تاريخ السفر ");
      }
      else if (this.travelBindObj.propoalObj.NoofDays <= 0) {
        this.travelBindObj.propoalObj.TravelTo = new Date();
        this.travelBindObj.propoalObj.TravelTo.setDate(this.curDate.getDate() + 1);
        this.travelBindObj.propoalObj.TravelFrom = new Date();
        this.travelBindObj.propoalObj.TravelFrom.setDate(this.curDate.getDate() + 1);
        this.travelBindObj.propoalObj.NoofDays = 1;
        this.Lng == "en" ? Swal("Travel To Must be greater than Travel From Date") : Swal("نهاية تاريخ السفر  يجب أن يكون أكبر من بداية تاريخ السفر ");
      }
    }

    //alert("From Date="+this.travelBindObj.propoalObj.TravelFrom+" To Date="+this.travelBindObj.propoalObj.TravelTo);

  }


  CalculateFromDays(DateType: string) {
    this.TravelFromDate = new Date();
    this.TravelFromDate = this.curDate;

    this.TravelToDate = new Date();
    this.TravelToDate = this.curDate;
    if (this.travelBindObj.propoalObj.TravelFrom.toString() == "Invalid Date") {
      this.travelBindObj.propoalObj.TravelFrom = new Date();
      this.travelBindObj.propoalObj.TravelFrom.setDate(this.curDate.getDate() + 1);
      this.travelBindObj.propoalObj.TravelTo = new Date();
      this.travelBindObj.propoalObj.TravelTo.setDate(this.curDate.getDate() + 1);
      this.travelBindObj.propoalObj.NoofDays = 1;
      this.Lng == "en" ? Swal("Enter Valid Date") : Swal("أدخل تاريخ صالح");
    }
    else {
      this.travelBindObj.propoalObj.TravelTo = this.travelBindObj.propoalObj.TravelFrom;
      this.travelBindObj.propoalObj.NoofDays = 1;

      let MDate: string;
      var date = this.travelBindObj.propoalObj.TravelFrom.getDate() < 10 ? "0" + this.travelBindObj.propoalObj.TravelFrom.getDate() : this.travelBindObj.propoalObj.TravelFrom.getDate();
      var month = this.travelBindObj.propoalObj.TravelFrom.getMonth() + 1 < 10 ? "0" + (this.travelBindObj.propoalObj.TravelFrom.getMonth() + 1) : this.travelBindObj.propoalObj.TravelFrom.getMonth() + 1;
      MDate = month + "/" + date.toString() + "/" + (this.travelBindObj.propoalObj.TravelFrom.getFullYear() + 1);
      this.maxDate = new Date(MDate);
      if (this.travelBindObj.propoalObj.TravelTo != null && this.travelBindObj.propoalObj.TravelFrom != null) {
        var difference_ms = 0;
        var one_day = 1000 * 60 * 60 * 24;

        // Convert both dates to milliseconds
        var date1_ms = this.travelBindObj.propoalObj.TravelFrom.getTime();
        var date2_ms = this.travelBindObj.propoalObj.TravelTo.getTime();
        this.From = date1_ms;
        this.To = date2_ms;
        // Calculate the difference in milliseconds
        var difference_ms = date2_ms - date1_ms;

        // Convert back to days and return
        this.travelBindObj.propoalObj.NoofDays = Math.ceil(difference_ms / one_day) + 1;
      }

      if (this.travelBindObj.propoalObj.TravelFrom < this.TravelFromDate) {
        this.travelBindObj.propoalObj.TravelTo = new Date();
        this.travelBindObj.propoalObj.TravelTo.setDate(this.curDate.getDate() + 1);
        this.travelBindObj.propoalObj.TravelFrom = new Date();
        this.travelBindObj.propoalObj.TravelFrom.setDate(this.curDate.getDate() + 1);
        this.travelBindObj.propoalObj.NoofDays = 1;
        this.Lng == "en" ? Swal("Travel From Date Must be Greater than Current Date") : Swal("يجب أن يكون بداية تاريخ السفر اكبرمن التاريخ الحالي");

      }
      if (this.travelBindObj.propoalObj.TravelTo != null) {
        if (this.travelBindObj.propoalObj.TravelTo < this.TravelToDate) {
          this.travelBindObj.propoalObj.TravelTo = new Date();
          this.travelBindObj.propoalObj.TravelTo.setDate(this.curDate.getDate() + 1);
          this.travelBindObj.propoalObj.TravelFrom = new Date();
          this.travelBindObj.propoalObj.TravelFrom.setDate(this.curDate.getDate() + 1);
          this.travelBindObj.propoalObj.NoofDays = 1;
          this.Lng == "en" ? Swal("Travel To Date Must be Greater than Current Date") : Swal("يجب أن يكون نهاية تاريخ السفر أكبر من التاريخ الحالي");
        }
        else if (this.travelBindObj.propoalObj.TravelTo < this.travelBindObj.propoalObj.TravelFrom) {
          this.travelBindObj.propoalObj.TravelTo = new Date();
          this.travelBindObj.propoalObj.TravelTo.setDate(this.curDate.getDate() + 1);
          this.travelBindObj.propoalObj.TravelFrom = new Date();
          this.travelBindObj.propoalObj.TravelFrom.setDate(this.curDate.getDate() + 1);
          this.travelBindObj.propoalObj.NoofDays = 1;
          this.Lng == "en" ? Swal("Travel To Must be greater than Travel From Date") : Swal("نهاية تاريخ السفر  يجب أن يكون أكبر من بداية تاريخ السفر ");

        }
        else if (this.travelBindObj.propoalObj.NoofDays <= 0) {
          this.travelBindObj.propoalObj.TravelTo = new Date();
          this.travelBindObj.propoalObj.TravelTo.setDate(this.curDate.getDate() + 1);
          this.travelBindObj.propoalObj.TravelFrom = new Date();
          this.travelBindObj.propoalObj.TravelFrom.setDate(this.curDate.getDate() + 1);
          this.travelBindObj.propoalObj.NoofDays = 1;
          this.Lng == "en" ? Swal("Travel To Must be greater than Travel From Date") : Swal("نهاية تاريخ السفر  يجب أن يكون أكبر من بداية تاريخ السفر ");

        }
      }
    }


  }

  AddPassanger(valid) {
    try {
      if (valid) {
        this.isShowLoading = true;
        this.IdExists = false;
        if (this.travelBindObj.propoalObj.passList.length > 0) {
          for (let i = 0; i < this.travelBindObj.propoalObj.passList.length; i++) {
            if (this.travelBindObj.propoalObj.passList[i].IdentityNo == this.passObj.IdentityNo) {
              this.Lng == "en" ? Swal("ID Number Already Exists") : Swal("رقم الهوية موجود بالفعل");
              this.IdExists = true;
            }
          }
        }
        if (this.travelBindObj.propoalObj.Insured_IDNo == this.passObj.IdentityNo) {
          this.Lng == "en" ? Swal("ID Number Already Exists") : Swal("رقم الهوية موجود بالفعل");
          this.isShowLoading = false;
          return;
        }

        if (!this.IdExists) {
          let newPassenger: PassMdl = new PassMdl();
          this.DOB = this.passObj.DOB.toString().substring(0, 15);
          this.DOB = new Date(this.DOB);
          this.DOB = this.formatDate(this.DOB);

          newPassenger.DOB = this.DOB;
          newPassenger.GenderCode = this.travelBindObj.relList.filter(t => t.RelationID.toString() == this.passObj.RelationShip)[0].GenderCode;
          newPassenger.RelationCode = this.travelBindObj.relList.filter(t => t.RelationID.toString() == this.passObj.RelationShip)[0].RelationID;
          newPassenger.GenderAr = this.passObj.GenderAr;
          newPassenger.GenderEn = this.passObj.GenderEn;
          newPassenger.IdentityNo = this.passObj.IdentityNo;
          newPassenger.NAME = this.passObj.NAME;
          newPassenger.NatAr = this.passObj.NatAr;
          newPassenger.NatEn = this.passObj.NatEn;
          newPassenger.NationalityCode = this.passObj.NationalityCode;
          newPassenger.PassportNo = this.passObj.PassportNo;
          newPassenger.RelationShip = this.travelBindObj.relList.filter(t => t.RelationID.toString() == this.passObj.RelationShip)[0].RelationNameEn;
          newPassenger.RelationShipAr = this.travelBindObj.relList.filter(t => t.RelationID.toString() == this.passObj.RelationShip)[0].RelationNameAr;
          newPassenger.RelationShipEn = this.travelBindObj.relList.filter(t => t.RelationID.toString() == this.passObj.RelationShip)[0].RelationNameEn;
          newPassenger.Sex = newPassenger.GenderCode.toString();
          newPassenger.NatEn = this.travelBindObj.natList.filter(t => t.NATCode == this.passObj.NationalityCode)[0].NATNameEn
          newPassenger.NatAr = this.travelBindObj.natList.filter(t => t.NATCode == this.passObj.NationalityCode)[0].NATNameAr
          newPassenger.IDCopy = this.passObj.IDCopy;
          newPassenger.IDCopyName = this.passObj.IDCopyName;
          newPassenger.PassportCopy = this.passObj.PassportCopy;
          newPassenger.PassportCopyName = this.passObj.PassportCopyName;
          this.travelBindObj.propoalObj.passList.push(newPassenger);
          this.passObj.NAME = null;
          this.passObj.PassportNo = null;
          this.passObj.IdentityNo = null;
          this.passObj.DOB = null;
          this.passObj.RelationShip = null;
          this.passObj.NationalityCode = null;
          this.passObj.IDCopy = null;
          this.passObj.IDCopyName = null;
          this.passObj.PassportCopy = null;
          this.passObj.PassportCopyName = null;
          this.modal = false;
          this.isShowLoading = false;
        }
        else {
          this.isShowLoading = false;
        }

      }
      else {
        this.Lng == "en" ? Swal("Please Enter All Fields") : Swal("يرجى إدخال جميع الحقول");
        this.isShowLoading = false;
      }

    }
    catch (error) {
      this.isShowLoading = false;
      Swal(error.name)
    }

  }


  DeleteMember(Member) {
    const index: number = this.travelBindObj.propoalObj.passList.indexOf(Member);
    if (index !== -1) {
      this.travelBindObj.propoalObj.passList.splice(index, 1);
    }
  }
  EditMember(Member) {
    this.passObj = Member;
    var date = new Date(Member.DOB)
    this.passObj.DOB = date;
    this.passObj.RelationShip = this.travelBindObj.relList.filter(t => t.RelationNameEn.toString() == this.passObj.RelationShip)[0].RelationID.toString();
    this.modal = true;
    const index: number = this.travelBindObj.propoalObj.passList.indexOf(Member);
    if (index !== -1) {
      this.travelBindObj.propoalObj.passList.splice(index, 1);
    }
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('/');
  }

  CalculatePremium() {

    this.isShowLoading = true;

    this.From = this.travelBindObj.propoalObj.TravelFrom.toString().substring(0, 15);
    this.From = new Date(this.From);
    this.travelBindObj.propoalObj.TravelFromDate = this.formatDate(this.From);
    this.EditTravelFromDate = this.travelBindObj.propoalObj.TravelFrom;

    this.To = this.travelBindObj.propoalObj.TravelTo.toString().substring(0, 15);
    this.To = new Date(this.To);
    this.travelBindObj.propoalObj.TravelToDate = this.formatDate(this.To);
    this.EditTravelToDate = this.travelBindObj.propoalObj.TravelTo;

    this.travelBindObj.propoalObj.PlanCode = "3" //DEPRICATED


    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.travelBindObj));

    this.http.post<mdlPayloadResponse>(this.url.baseURL + "travelBind/getPremium", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.isShowLoading = false;

      //New Line Start
      this.objPayloadResponse = result;

      let objResObj: TravelBindMdl = new TravelBindMdl();
      objResObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));



      if (objResObj.propoalObj.RegNo != this.travelPolicyObj.RegNo) {
        Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
        this.router.navigate(['BeforeLogin/NewReg']);
        return;
      }
      this.travelBindObj = objResObj;
      //NewLine End
      if (this.travelBindObj.st.StatusCode === "S") {
        sessionStorage.setItem("TravelBindObj", this.EncriptService.EncriptObject(JSON.stringify(this.travelBindObj)));
        sessionStorage.setItem("CurrentRoute", "TravelPolicyConfirm");
        this.router.navigate(['NewDashboard/TravelPolicyConfirm']);

      }
      else {
        this.travelBindObj.propoalObj.TravelFrom = this.EditTravelFromDate;
        this.travelBindObj.propoalObj.TravelTo = this.EditTravelToDate;
        this.isShowLoading = false;
        this.Lng == "en" ? Swal(this.travelBindObj.st.StatusDesc) : Swal(this.travelBindObj.st.StatusDescAr);
      }
    }, (error) => {
      this.isShowLoading = false;
      this.userinfo.checkTokenStatus(error);
      this.Lng == "en" ? Swal("Try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
    });
  }

  Individual() {

    if (this.travelBindObj.propoalObj.InsuranceType == '1') {
      if (this.travelBindObj.propoalObj.passList.length > 0) {
        this.travelBindObj.propoalObj.passList.length = 0;
      }
    }


  }

  ValidateDOB(DOB) {

    var valid = moment(DOB, 'dd/mm/yyyy').isValid();
    var years = moment().diff(DOB, 'years');

    if (DOB == "Invalid date" || DOB == '' || DOB == null || DOB == "Invalid Date") {

      this.passObj.DOB = "";
    }
    else if (years > 100) {
      this.Lng == "en" ? Swal("Enter Valid Date") : Swal("أدخل تاريخ صالح");
      this.passObj.DOB = "";
    }
    else {
      if (this.passObj.DOB > this.DoBmaxDate) {
        this.Lng == "en" ? Swal("Date Of Birth Must Be Less than Current Date") : Swal("تاريخ الميلاد يجب أن يكون أقل من التاريخ الحالي");
        this.passObj.DOB = "";
      }
    }

  }

  OnSelectIDCopy(event, passObj) {
    if (this.passObj.IdentityNo == undefined || this.passObj.IdentityNo == null) {
      Swal("Please Enter Id Number");
      return;
    }

    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      this.passObj.IDCopyName = this.travelBindObj.propoalObj.RegNo.toString() + "_" + passObj.IdentityNo + "_IdCopy." + fileExt;
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        Swal("Please select valid image");
        return;
      }

      var isvalid = "";
      if (fsize > 2) {
        Swal("File Size Should not exceed 2 MB");
        return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "IdCopy");
      fd.append("attchmentId", this.travelBindObj.propoalObj.RegNo.toString() + "_" + passObj.IdentityNo)

      this.uploadFile(fd, this.passObj.IDCopyName);
      reader.onload = (event) => {
        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.passObj.IDCopy = image.split(",")[1];
        }


      }
    }
  }
  OnSelectPassportCopy(event, passObj) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      this.passObj.PassportCopyName = this.travelBindObj.propoalObj.RegNo.toString() + "_" + passObj.IdentityNo + "_PassportCopy." + fileExt;
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        Swal("Please select valid image");
        return;
      }

      var isvalid = "";
      if (fsize > 2) {
        Swal("File Size Should not exceed 2 MB");
        return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "PassportCopy");
      fd.append("attchmentId", this.travelBindObj.propoalObj.RegNo.toString() + "_" + passObj.IdentityNo)

      this.uploadFile(fd, this.passObj.PassportCopyName);
      reader.onload = (event) => {
        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.passObj.PassportCopy = image.split(",")[1];
        }


      }
    }
  }


  uploadFile(fd, CopyName) {
    var param = environment;              
    if (!param.St.StatusDesc) {
        throw new Error("Encryption key is not initialized.");
    }

    var UserName = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Code));
    var Password = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Description));
    
    this.isShowLoading = true;

    this.headers = new HttpHeaders();
    this.headers.delete('Content-Type');
    this.headers.set('enctype', "multipart/form-data");
    this.headers = this.headers.append('Accept-Encoding', 'gzip');
    this.headers = this.headers.append('apiToken', this.getToken());
    this.headers = this.headers.append("Authorization", "Basic " + btoa(UserName + ':' + Password));

    this.http.post<MotorStatusMdl>(this.url.baseURL + "/Proposal/SaveAttachments", fd, { headers: this.headers }).toPromise().then(
      (res) => {
        this.isShowLoading = false;
        if (res.StatusCode == "F") {
          swal(res.StatusDesc);
          this.AttachementError = this.AttachementError + CopyName;
          return;
        }
        else {
          this.AttachementError = this.AttachementError.replace(CopyName, "");
        }

      }, (error) => {
        this.isShowLoading = false;
      });

  }

  getToken(): string {
    let token: string = "";
    if (sessionStorage.getItem("token") != null) {
      token = sessionStorage.getItem("token");
    }
    return token;
  }

  myFunction(dropdownID) {
    this.searchAir = "";
    document.getElementById(dropdownID).classList.toggle("show");
  }
  filterFunction(inputID, dropdownID) {
    var input, filter, ul, li, a, i;
    input = document.getElementById(inputID);
    filter = input.value.toUpperCase();
    var div = document.getElementById(dropdownID);
    a = div.getElementsByTagName("option");
    for (i = 0; i < a.length; i++) {
      var txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";
      } else {
        a[i].style.display = "none";
      }
    }
  }
  getDepartureValue(obj) {
    // this.travelBindObj.propoalObj.DepartureAirport = this.Lng == "en"? obj.DestinationNameEn: obj.DestinationNameAr;
    this.travelBindObj.propoalObj.DepartureAirport = obj.DestinationId;
    let airp = this.Lng == "en" ? this.travelBindObj.destList.filter(t => t.DestinationNameEn == obj.DestinationNameEn)[0] : this.travelBindObj.destList.filter(t => t.DestinationNameAr == obj.DestinationNameAr)[0];
    document.getElementById("optionDeparture").innerHTML = this.Lng == "en" ? airp.DestinationNameEn : airp.DestinationNameAr
    document.getElementById('myDepartureDropdown').style.display = "none";
    document.getElementById('myDepartureDropdown').classList.remove('show');
  }


}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TraveNewProposal/TravelNewProposal.ts